import { motion } from 'framer-motion';
import { ExternalLink, Github, Star } from 'lucide-react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const ProjectsWindow = () => {
  /*
  const projects = [
    {
      title: 'AI Assistant Platform',
      description: 'Enterprise-grade conversational AI platform with natural language processing, multi-language support, and advanced analytics.',
      tech: ['React', 'Node.js', 'OpenAI', 'MongoDB', 'WebSocket'],
      status: 'Production',
      stars: 342,
      link: '#',
      github: '#'
    },
    {
      title: 'Real-time Analytics Dashboard',
      description: 'High-performance data visualization platform processing millions of events per second with real-time insights.',
      tech: ['Next.js', 'Python', 'Redis', 'PostgreSQL', 'D3.js'],
      status: 'Production',
      stars: 189,
      link: '#',
      github: '#'
    },
    {
      title: 'E-commerce Microservices',
      description: 'Scalable microservices architecture for e-commerce with payment integration, inventory management, and order processing.',
      tech: ['Go', 'Kubernetes', 'gRPC', 'MongoDB', 'RabbitMQ'],
      status: 'Production',
      stars: 256,
      link: '#',
      github: '#'
    },
    {
      title: 'IoT Device Manager',
      description: 'Cloud-based IoT device management system with real-time monitoring, remote control, and predictive maintenance.',
      tech: ['React', 'AWS IoT', 'Python', 'InfluxDB', 'MQTT'],
      status: 'Beta',
      stars: 128,
      link: '#',
      github: '#'
    },
    {
      title: 'Machine Learning Pipeline',
      description: 'Automated ML pipeline for training, deploying, and monitoring machine learning models at scale.',
      tech: ['Python', 'TensorFlow', 'Kubeflow', 'MLflow', 'Docker'],
      status: 'Development',
      stars: 95,
      link: '#',
      github: '#'
    },
    {
      title: 'Blockchain Explorer',
      description: 'Advanced blockchain explorer with transaction tracking, smart contract analysis, and network statistics.',
      tech: ['Vue.js', 'Web3.js', 'Node.js', 'MongoDB', 'GraphQL'],
      status: 'Production',
      stars: 203,
      link: '#',
      github: '#'
    }
  ];
  */

  return (
    <div className="space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-4xl font-bold glow-text mb-2">Featured Projects</h1>
        <p className="text-muted-foreground">A selection of my most impactful work</p>
      </motion.div>

      {/* Projects Grid */}
      <div className="flex flex-col items-center justify-center py-20 border-2 border-dashed border-primary/20 rounded-2xl bg-primary/5">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="text-center space-y-4"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <Star className="w-8 h-8 text-primary animate-pulse" />
          </div>
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">Coming Soon</h2>
          <p className="text-muted-foreground max-w-[400px] mx-auto">
            I'm currently documenting my latest technical projects. Check back soon to see my full portfolio.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default ProjectsWindow;